export const DEBUG_FLAG = 'debug'

// TODO: Test if Vercel still works without these hardcoded defaults
export const PROD_PUBLIC_API_BASE = 'https://public-api.lmucs.io'

export const PUBLIC_API_BASE = process.env.REACT_APP_PUBLIC_API || PROD_PUBLIC_API_BASE
